<template>
  <div class="container-md">
    <div  class="card border-primary shadow-lg">
      <div class="card-header text-white bg-primary">
        <div class="row">
          <div class="col-12 col-sm-6">
            <h2>{{ client.name }}</h2>
            <label>{{ client.regNumber }}</label>
          </div>
          <div class="col-12 col-sm-6 text-start text-sm-end">
            <label v-if="client.balance < 0" class="text-warning m-0 m-sm-4"><b>{{ $t('balance.debt') }} {{ Math.round(client.balance * 100) / 100 }}</b></label>
            <label v-else class="m-0 m-sm-4"><b>{{ $t('balance.invoices-paid') }}</b></label>
          </div>
        </div>
      </div>

      <div class="card-body">
        <TableField
            v-model:params="params"
            :data="invoices"
            :columns="columns"
            :loading="loading"
            local
            stickyHeader
            columnChooser
            mobileDevices
            section="balance"
        />
      </div>
    </div>
  </div>
</template>

<script src="./Balance.js"></script>